<template>
  <a-modal title="添加原料"
    :visible="hidden" 
    @ok="ok" 
    :bodyStyle="{padding:'10px'}"
    :destroyOnClose="true"
    :forceRender="true"
    @cancel="cancel"
    width="900px">
      <a-row style="padding:0 0 15px" type="flex" align="middle" justify="space-between">
        <a-col>
          <a-input-search cl size="small" v-model="filterData.name" @change="e => inputChange(e,'name')" placeholder="原料名称/代码" style="width: 180px;margin-right: 10px;" @search="e => onSearch(e,'name')" />
          <a-input-search v-if="overseasFlag==1" size="small" v-model="filterData.aliasName" @change="e => inputChange(e,'aliasName')" placeholder="原料别名" style="width: 180px" @search="e => onSearch(e,'aliasName')" />
        </a-col>
        <base-list-select style="width:400px" :value="rawType" @change="typeChange" placeholder="选择原料类型" category="raw" />
      </a-row>
      <a-table
        :columns="columns"
        :scroll="{ x:0, y: 450 }"
        :row-selection="rowSelection"
        :loading="nutLoading"
        :data-source="list.records"
        :row-key="record => record.id"
        :pagination="pagination"
        @change="listChange"
      >
      
        <template slot="name" slot-scope="text,record">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>
      </a-table>
      <div style="position: absolute;bottom: 10px;left: 10px;">已选中<span style="color: red;">{{selectedRowKeys.length}}</span>个原料</div>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils'
import BaseListSelect from '../select/BaseListSelect.vue'
export default {
  components: { BaseListSelect },
  props:['hidden'],
  mixins:[nhfMixins],
  data(){
    return{
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      nutLoading:false,
      filterData:{},
      list:{},
      showFooter:false,
      rawType:[],
      columns:[
        { 
          dataIndex:'name',
          title: '原料名称',
          width:300,
          scopedSlots: {customRender: 'name'},
        },
        {
          dataIndex:'code',
          align:'center',
          title: '代码',
          width:110
        },
        {
          dataIndex:'rawTypeName',
          title: '类型',
        },
        {
          dataIndex:'unit',
          title: '单位',
          align:'center',
        },
      ]
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChangeControl,
        getCheckboxProps: record => {
          return ({
            props: {
              disabled: this.selectedRowKeys.length >= 20 && !this.selectedRowKeys.includes(record.id)
            },
          })
        },
      };
    },
  },
  mounted(){
    // this.getList()
  },
  watch:{
    hidden(val){
      if(val) {
        this.filterData = {}
        this.rawType = []
        this.$nextTick(()=>{
          let {current=1,pageSize=100} = this.pagination || {}
          this.getList({current,size: pageSize})
        })
      }
    }
  },
  methods:{
    onSelectChangeControl(selectedRowKeys, selectedRows) {
      selectedRowKeys = selectedRowKeys.filter((v,i) => i < this.maxLen)
      this.selectedRowKeys = selectedRowKeys
      let arr = [...this.selectedRows, ...selectedRows]
      this.selectedRows = selectedRowKeys.map((i) => {
        return arr.filter((item) => item.id === i)[0]
      })
      this.list.records = [...this.list.records]
    },
    inputChange({target},feild){
      let {current=1,pageSize=100} = this.pagination || {}
      this.getList({[feild]:target.value,current,size: pageSize})
    },
    ok(){
        if(this.selectedRows.length){
        this.filterData = {}
        this.$emit('ok',this.selectedRows)
        this.cleanSelect()
        let {current=1,pageSize=100} = this.pagination || {}
        this.getList({current,size: pageSize})
      }else{
        this.$message.warn('选择需要添加的原料')
      }
    },
    
    cancel(){
      this.filterData = {}
      this.cleanSelect()
      this.$emit('cancel')
    },

    getList(arg ={}){
      return this.fetchGet({
        actions:this.mixAddBlendPage,
        isList:true,
        name:'list',
        loading:'nutLoading',
        data:{
          ...this.filterData,
          factoryId:this.factoryId,
          formulaId:this.formulaId,
          ...arg,
        }
      })
    },

    onSearch(name,feild){
      let {current=1,pageSize=100} = this.pagination || {}
      this.getList({[feild]:name,current,size: pageSize})
    },

    typeChange(val){
      this.rawType = val
      const typeId = [...val].pop()
      this.filterData.typeId = typeId
      let {current=1,pageSize=100} = this.pagination || {}
      this.getList({typeId,current,size: pageSize})
    },

    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
  }
}
</script>
